'use strict';

import FAQView from 'standard-vote/app/scripts/views/faq.js';

module.exports = FAQView;



// WEBPACK FOOTER //
// ./app/scripts/views/faq.js